import data from '../../environment.json';

export function getGit() {
  return data && data.git ? data.git : 'UNKNOWN'
}

export function getVersion() {
  return data && data.version ? data.version : 'UNKNOWN'
}

export function getBranch() {
  return data && data.branch ? data.branch : 'UNKNOWN'
}
